import React from 'react';
import PropTypes from 'prop-types';

import { useContext as useUserContext } from 'components/Users/Context';

const hasPermission = (permissions, scopes) => {
  let available = false;

  Object.entries(scopes).forEach((entry) => {
    const [key, values] = entry;
    if (!available && permissions[key] && values.includes(permissions[key])) {
      available = true;
    }
  });
  return available;
};

export default function PermissionsGate({ children, scopes }) {
  const { state: stateUser } = useUserContext();

  if (stateUser.user === null || !hasPermission(stateUser.user.attributes.permissions, scopes)) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
}

PermissionsGate.propTypes = {
  children: PropTypes.element.isRequired,
  scopes: PropTypes.object,
};

PermissionsGate.defaultProps = {
  scopes: {},
};
